import axios from 'axios'
import store from '../store.js'

const ajax = {
  request (method, url, data, options, headers) {
    const storategy = process.env.AUTH_STORATEGY
    options = Object.assign(
      {
        loading: true,
        noAuth: false
      },
      options || {}
    )
    headers = headers || {}
    return new Promise((resolve, reject) => {
      if (options.loading) {
        store.dispatch('common/loading/startLoading')
      }
      store
        .dispatch(`common/${storategy}/refresh`)
        .then(() => {
          if (!options.noAuth) {
            const authorization =
              store.getters[`common/${storategy}/authorization`]
            headers['Authorization'] = authorization
          }
          return axios.request({
            url: url,
            data: data,
            headers: headers,
            method: method.toLowerCase()
          })
        })
        .then(response => {
          return resolve(response)
        })
        .catch(error => {
          return reject(
            (error.response && error.response.data.messages) || [],
            error
          )
        })
        .finally(() => {
          if (options.loading) {
            store.dispatch('common/loading/endLoading')
          }
        })
    })
  },

  get (url, options = {}, headers = {}) {
    return this.request('get', url, {}, options, headers)
  },
  delete (url, options = {}, headers = {}) {
    return this.request('delete', url, {}, options, headers)
  },
  head (url, options = {}, headers = {}) {
    return this.request('head', url, {}, options, headers)
  },
  options (url, options = {}, headers = {}) {
    return this.request('options', url, {}, options, headers)
  },
  post (url, data, options = {}, headers = {}) {
    return this.request('post', url, data, options, headers)
  },
  put (url, data, options = {}, headers = {}) {
    return this.request('put', url, data, options, headers)
  },
  patch (url, data, options = {}, headers = {}) {
    return this.request('patch', url, data, options, headers)
  },

  _init () {
    axios.defaults.baseURL = process.env.APP_API_URL
  }
}

ajax._init()
export default ajax



// WEBPACK FOOTER //
// ./src/common/services/ajax.js